import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initMercadoPago } from "@mercadopago/sdk-react";
import "@/index.css";
import App from "@/App";

const mpPublicKey = process.env.REACT_APP_MP_PUBLIC_KEY;
if (mpPublicKey) initMercadoPago(mpPublicKey);

// Remove o overlay de erro do dev server causado pelo script anti-fraude do Mercado Pago
const removeMpNoiseOverlay = () => {
  const overlay = document.getElementById("webpack-dev-server-client-overlay");
  if (!overlay) return;
  try {
    const txt = overlay.contentDocument?.body?.innerText || "";
    if (txt.includes("Failed to fetch")) overlay.remove();
  } catch {
    /* ignora */
  }
};
new MutationObserver(removeMpNoiseOverlay).observe(document.documentElement, {
  childList: true,
  subtree: true,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
